// Main application entry point
// This file controls the exact order of execution

// 1. First: Initialize scroll-based color changing
import { ScrollColorUpdater } from './utils/scroll-color.js';

// 2. Then: UI snippet components used across site
import './snippets/blocks.js';
import './snippets/nav-main.js';
import { initGalleryControls } from './snippets/gallery-controls.js';
import { enableHorizontalScrollBubble } from './utils/horizontal-scroll-bubble.js';
import { addInViewClass } from './utils/inview-class.js';

// 3. Initialize scroll color updater
new ScrollColorUpdater();

// 4. Initialize gallery controls
initGalleryControls();

// 5. Enable horizontal scroll bubble
enableHorizontalScrollBubble();

// 6. Add inview class to elements
addInViewClass();